import { render } from "./InfoAboutActionLog.vue?vue&type=template&id=156ecbbe&scoped=true&ts=true"
import script from "./InfoAboutActionLog.vue?vue&type=script&lang=ts"
export * from "./InfoAboutActionLog.vue?vue&type=script&lang=ts"

import "./InfoAboutActionLog.vue?vue&type=style&index=0&id=156ecbbe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-156ecbbe"]])

export default __exports__